import React from "react";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useExportLevelCReport } from "../../hooks/levelc-reports/useExportLevelDReport";
import { LevelCReportFilter } from "../../types/levelc-reports";

interface LevelCExportButtonProps {
  filter: LevelCReportFilter;
}

export const LevelCExportButton: React.FC<LevelCExportButtonProps> = ({ filter }) => {
  const { t } = useTranslation();
  const { exportToExcel, isExporting } = useExportLevelCReport();

  return (
    <Tooltip title={t("levelCReports.export.tooltip")}>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        loading={isExporting}
        onClick={() => exportToExcel(filter)}
      >
        {t("levelCReports.export.button")}
      </Button>
    </Tooltip>
  );
};

